import React from "react";
import {
  Navigate,
} from "react-router-dom";


const ScheduleListComponent = React.lazy(() => import("../../../components/schedule/components/list/page"));
const ScheduleCreateComponent = React.lazy(() => import("../../../components/schedule/components/add/calendar"));
const ScheduleApprovedComponent = React.lazy(() => import("../../../components/requests-approved/components/list/page"));
const ScheduleRejectedComponent = React.lazy(() => import("../../../components/requests-rejected/components/list/page"));


export const schedulesRoute = [
  {
    path: 'request',
    element: <ScheduleListComponent />,
  },
  {
    path: 'show',
    element: <ScheduleCreateComponent />,
  },
   {
    path: 'approved',
    element: <ScheduleApprovedComponent />,
  },
  {
    path: 'rejected',
    element: <ScheduleRejectedComponent />,
  },
  {
    path: '',
    element: <Navigate replace to="/schedule/show" />
  },
]